/**
 * @Author: chengzh
 * @Date:   2021-06-15 17:46:03
 * @Last Modified by:   chengzh
 * @Last Modified time: 2021-08-13 18:04:14
 */
import React, { useState, useEffect, useImperativeHandle } from 'react';
import { Form } from 'antd';
import QueryString from 'query-string';
import _ from 'lodash';
import clsx from 'clsx';

const FormItem = Form.Item;
const FloatLabel = props => {
  const [focus, setFocus] = useState(false);
  const [labelClass, setLabelClass] = useState('');
  let styleObj = {};
  if (typeof window !== 'undefined') {
    styleObj = QueryString.parse(location.search);
  }

  const {
    bolderColor,
    color,
    fontFamily,
    fontSize,
    fontSmoothing,
    fontWeight,
    floatLabelSize,
    floatLabelColor,
    floatLabelWeight,
  } = styleObj;
  // backgroundColor: '#f8f8f8',
  // bolderColor: '#f1f1f1',
  // color: '#bcbcbc',
  // fontWeight: '400',
  // fontFamily: 'Roboto, Open Sans, Segoe UI, sans-serif',
  // fontSize: '14px',
  // fontSmoothing: 'antialiased',
  // floatLabelSize: '12px',
  // floatLabelColor: '#333333',
  // floatLabelWeight: '100',
  const _bolderColor = bolderColor ? bolderColor : '#f1f1f1';
  const _color = color ? color : '#666666';
  const _fontFamily = fontFamily
    ? fontFamily
    : 'Roboto, Open Sans, Segoe UI, sans-serif';
  const _fontSize = fontSize ? fontSize : '14px';
  const _fontSmoothing = fontSmoothing ? fontSmoothing : 'auto';
  const _fontWeight = fontWeight ? fontWeight : 'normal';
  const _floatLabelSize = floatLabelSize ? floatLabelSize : '12px';
  const _floatLabelColor = floatLabelColor ? floatLabelColor : '#333333';
  const _floatLabelWeight = floatLabelWeight ? floatLabelWeight : 'normal';
  // nativeSelect 暂时提供给原生select使用,
  const {
    children,
    form,
    placeholder,
    nativeSelect,
    name,
    label,
    // rules,
    // style,
  } = props;
  useEffect(() => {
    setLabelClassFn();
  }, []);
  useImperativeHandle(props.cref, () => ({
    // changeVal 就是暴露给父组件的方法
    setLabelClass: () => {
      setLabelClassFn();
    },
    setFormItemFocus: () => {
      onFocus()
    },
  }));
  const setLabelClassFn = () => {
    const myValue = form.getFieldValue(name);
    if (
      focus ||
      !_.isEmpty(myValue) ||
      !_.isEmpty(placeholder) ||
      nativeSelect
    ) {
      setLabelClass('h5-label-float');
    } else {
      setLabelClass('h5-label-normal');
    }
  };
  useEffect(() => {
    setLabelClassFn();
  }, [focus]);
  const onBlur = e => {
    setFocus(false);
  };
  const onFocus = e => {
    setFocus(true);
    const inputDom = document.getElementById(name);
    inputDom.focus();
    // positionAdjust();
  };

  const positionAdjust = () => {
    // 获取对应事件的 input dom
    const inputDom = document.getElementById(name);
    // const topDom = document.getElementById('__next');
    setTimeout(() => {
      // px to rem 的比例
      const rate =
        (window.screen.width || document.documentElement.clientWidth) / 375;
      // 底部按钮 375基准 的高度为 56，根据 rate 计算实际高度
      const bottomFixHeight = 56 * rate;

      // 高度计算
      const clientHeight = document.documentElement.clientHeight;
      const top = inputDom.getBoundingClientRect().top;
      const diff = clientHeight - top;
      // console.info('clientHeight', clientHeight);
      // console.info('top', top);
      // console.info('diff', diff);
      // console.info('bottomFixHeight', bottomFixHeight);
      // scrollIntoViewIfNeeded 无法处理 input 和 底部按钮重合的部分
      // input 在 button 上方，或者 input 与 button 重合，修改外层 scrollTop
      // input 在 button 下方，使用 scrollIntoViewIfNeeded
      // if (diff >= 0 && diff < bottomFixHeight) {
      //   // console.info('topDom.scrollTop', topDom.scrollTop);
      //   // topDom.scrollTop = topDom.scrollTop + bottomFixHeight * 3;
      // } else {
      //   inputDom.scrollIntoView({
      //     behavior: 'auto',
      //     block: 'nearest',
      //     inline: 'nearest',
      //   });
      //   // inputDom.scrollIntoViewIfNeeded(true);
      // }
      // 当浏览器高度减上面的高度<300时候，说明元素在键盘下面，此时需要调整位置
      if (diff < 350) {
        inputDom.scrollIntoView({
          behavior: 'auto',
          block: 'center',
          inline: 'nearest',
        });
      }
    }, 200);
  };

  return (
    <div>
      <style jsx global>{`
        .h5-card-elements-field input {
          border: 1px solid ${_bolderColor};
          font-family: ${_fontFamily};
          -webkit-font-smoothing: ${_fontSmoothing};
          -moz-osx-font-smoothing: ${_fontSmoothing};
        }
        .h5-label-normal label {
          font-size: ${_fontSize};
          color: ${_color};
          font-weight: ${_fontWeight};
        }
        .h5-label-float label {
          font-size: ${_floatLabelSize};
          color: ${_floatLabelColor};
          font-weight: ${_floatLabelWeight};
        }
      `}</style>
      <FormItem
        {...props}
        className={clsx('h5-card-elements-field', labelClass)}
        name={name}
        label={label}
        // rules={rules}
        // style={styleObj}
        onBlur={e => onBlur(e)}
        onFocus={e => onFocus(e)}
      >
        {children}
      </FormItem>
    </div>
  );
};

export default FloatLabel;
